import { useState } from 'react';
import { useStyles } from '@archipro-design/aria';
import * as S from './PaintColour.style';
import { motion } from 'framer-motion';
import { Colour } from '@modules/paint-picker/component/paint-colours/Colour';
import type { PaintProduct } from '@modules/paint-picker/type';
import PaintColourActions from './PaintColourActions';
import { useTracker } from '@archipro-website/tracker';
import { usePaintPickerContext } from '../../context/PaintPickerContext';

interface PaintColourProps extends PaintProduct {
    isPreview?: boolean;
    onClick?: () => void;
}

export const PaintColour = ({
    id,
    productId,
    title,
    link,
    code,
    rgb,
    isPreview,
    onClick,
}: PaintColourProps) => {
    const { paintSelection } = usePaintPickerContext();
    const { css } = useStyles({
        isPreview: isPreview,
        useBottomDivider: isPreview && paintSelection.length > 0,
        showHoverCursor: !!onClick,
    });
    const tracker = useTracker();
    const [showActions, setShowActions] = useState(false);
    const [keepActionsOpen, setKeepActionsOpen] = useState(false);

    const displayActions = keepActionsOpen || showActions;

    return (
        <motion.li
            variants={S.rowAnimation}
            className={css(S.ColourRow)}
            onMouseEnter={() => setShowActions(true)}
            onMouseLeave={() => setShowActions(false)}
            onClick={onClick}
        >
            <div className={css(S.ColourDetails)}>
                <p className={css(S.ColourName)}>{title}</p>
                <p className={css(S.ColourCode)}>{code}</p>

                {!isPreview && link && (
                    <a
                        target="_blank"
                        className={css(S.ProductLink)}
                        href={link}
                        rel="noopener"
                        onClick={() => {
                            tracker.log(
                                'Resene-PaintPicker-Hover-Order-Testpot',
                                {
                                    url: new URL(window.location.href),
                                }
                            );
                        }}
                    >
                        Get sample
                    </a>
                )}
            </div>
            {productId && (
                <PaintColourActions
                    show={displayActions}
                    productId={productId}
                    id={id}
                    title={title}
                    isPreview={isPreview}
                    onOpenDesignBoard={() => setKeepActionsOpen(true)}
                    onCloseDesignBoard={() => {
                        setKeepActionsOpen(false);
                        setShowActions(false);
                    }}
                />
            )}
            <Colour show={!displayActions} rgb={rgb} />
        </motion.li>
    );
};
